import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "relative w-full" }
const _hoisted_2 = { class: "flex-1 flex items-center justify-end" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_8 = { class: "hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Print = _resolveComponent("Print")!
  const _component_ModalCompleteCargo = _resolveComponent("ModalCompleteCargo")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.progress === 0 && _ctx.formBooking.cargoType === 'plane' && _ctx.formBooking.cargoTypeStatus === 'auto')
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            (_ctx.nextCotHour && !_ctx.isChangeCargoType)
              ? (_openBlock(), _createBlock(_component_LpButton, {
                  key: 0,
                  onClick: _ctx.onBookingRtc,
                  title: _ctx.$t('revamp.booking.bookNow'),
                  textColor: "white",
                  disabled: !_ctx.isFormBookingValid || _ctx.isLoadingCalculateVolume
                }, null, 8, ["onClick", "title", "disabled"]))
              : (_ctx.cotHour && !_ctx.isChangeCargoType)
                ? (_openBlock(), _createBlock(_component_LpButton, {
                    key: 1,
                    onClick: _ctx.checkEligible,
                    title: _ctx.$t('revamp.booking.bookNow'),
                    textColor: "white",
                    disabled: !_ctx.isFormBookingValid || _ctx.isLoadingCalculateVolume
                  }, null, 8, ["onClick", "title", "disabled"]))
                : (_openBlock(), _createBlock(_component_LpButton, {
                    key: 2,
                    onClick: _cache[1] || (_cache[1] = () => _ctx.checkEligible(false)),
                    title: _ctx.$t('revamp.booking.selectSchedule'),
                    textColor: "white",
                    disabled: !_ctx.isFormBookingValid || _ctx.isLoadingCalculateVolume
                  }, null, 8, ["title", "disabled"])),
            _createVNode(_component_OverlayPanel, {
              ref: "op",
              appendTo: "body",
              style: {"width":"auto"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LpButton, {
                  class: "w-60",
                  onClick: _ctx.onBookingRtc,
                  flat: "",
                  dense: "",
                  small: "",
                  isWidthFull: "",
                  textAlign: "justify-start",
                  iconLeft: "cargo",
                  bgColorHover: "red-lp-50",
                  textColorHover: "red-lp-100",
                  title: _ctx.$t('Booking sekarang')
                }, null, 8, ["onClick", "title"]),
                _hoisted_4,
                _createVNode(_component_LpButton, {
                  class: "w-full",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showModalPlaneAuto(true))),
                  flat: "",
                  dense: "",
                  bgColorHover: "red-lp-50",
                  textColorHover: "red-lp-100",
                  small: "",
                  isWidthFull: "",
                  textAlign: "justify-start",
                  iconLeft: "calendar-outlined",
                  title: _ctx.$t('Pilh jadwal')
                }, null, 8, ["title"])
              ]),
              _: 1
            }, 512)
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode(_component_LpButton, {
              onClick: _ctx.togglePanel,
              icon: _ctx.iconTogglePanel,
              title: _ctx.$t('Proses Kargo'),
              textColor: "white",
              disabled: !_ctx.isFormBookingValid || _ctx.isLoadingCalculateVolume
            }, null, 8, ["onClick", "icon", "title", "disabled"]),
            _createVNode(_component_OverlayPanel, {
              ref: "op",
              appendTo: "body",
              style: {"width":"auto"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LpButton, {
                  class: "w-60",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.createAndPrint(false))),
                  flat: "",
                  dense: "",
                  iconLeft: "cargo",
                  title: _ctx.$t('Booking Kargo')
                }, null, 8, ["title"]),
                _hoisted_6,
                _createVNode(_component_LpButton, {
                  class: "w-full",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.createAndPrint(true))),
                  flat: "",
                  dense: "",
                  iconLeft: "printer",
                  title: _ctx.$t('Booking & Print PDF')
                }, null, 8, ["title"]),
                _hoisted_7,
                _createVNode(_component_LpButton, {
                  class: "w-full",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.createAndPrint(false, true))),
                  flat: "",
                  dense: "",
                  iconLeft: "invoice-gray",
                  title: "Booking & Print Label"
                })
              ]),
              _: 1
            }, 512)
          ]))
    ]),
    (_ctx.isShowPopup)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          customWidth: _ctx.isPartial ? '480px' : '360px',
          onSubmit: _ctx.popupModalData?.success?.action,
          onClose: _ctx.popupModalData?.cancel?.action,
          title: _ctx.popupModalData.title,
          message: _ctx.popupModalData.message,
          image: _ctx.popupModalData.image,
          textSuccess: _ctx.popupModalData?.success?.text,
          textCancel: _ctx.popupModalData?.cancel?.text,
          class: "px-8"
        }, null, 8, ["customWidth", "onSubmit", "onClose", "title", "message", "image", "textSuccess", "textCancel"]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_8, [
      _createVNode(_component_Print, { ref: "print" }, null, 512)
    ]),
    (_ctx.isShowModalComplete)
      ? (_openBlock(), _createBlock(_component_ModalCompleteCargo, {
          key: 1,
          onOnSubmit: _cache[6] || (_cache[6] = ($event: any) => (_ctx.createAndPrint(false)))
        }))
      : _createCommentVNode("", true)
  ]))
}